export default __webpack_public_path__ + "static/graphic_personal-details_small-0d2b45b4b3401fcc3797fd4e13c9bd63.png";